document.addEventListener("DOMContentLoaded", function () {
  const marqueeSlider = document.querySelector("[data-sliding-text]");
  if (!marqueeSlider) return;

  const mainTicker = new Flickity(marqueeSlider, {
    accessibility: true,
    resize: true,
    wrapAround: true,       // clones ends for seamlessness
    prevNextButtons: false,
    pageDots: false,
    percentPosition: true,
    setGallerySize: true,
    groupCells: false
  });

  // mobile pe thoda slow
  let speed = window.innerWidth <= 768 ? 0.5 : 1.2;
  let requestId;
  mainTicker.x = 0;         // Flickity internal position

  function tick() {
    // hamesha left ki taraf
    mainTicker.x -= speed;
    mainTicker.settle(mainTicker.x);

    // slideable width cross ho jaye to x ko wrap kar do (no reverse)
    const w = mainTicker.slideableWidth || 0;
    if (w > 0 && Math.abs(mainTicker.x) >= w) {
      // x -w se aage nikal gaya to w add karke position ko loop kara do
      mainTicker.x += w;
      mainTicker.settle(mainTicker.x);
    }

    requestId = requestAnimationFrame(tick);
  }

  function play() {
    if (!requestId) requestId = requestAnimationFrame(tick);
  }

  function pause() {
    if (requestId) {
      cancelAnimationFrame(requestId);
      requestId = undefined;
    }
  }

  // hover = pause/resume
  marqueeSlider.addEventListener("mouseenter", pause);
  marqueeSlider.addEventListener("mouseleave", play);

  // tab hidden ho to CPU bachao
  document.addEventListener("visibilitychange", () => {
    document.hidden ? pause() : play();
  });

  // resize pe speed update (optional)
  window.addEventListener("resize", () => {
    speed = window.innerWidth <= 768 ? 0.5 : 1.2;
  });

  play();
});
